<template>
    <div>
        <div v-if="!addNew">
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Store name" | t }}</v-col>
                <v-col cols="6">
                    <v-autocomplete
                        v-model="storesComplete"
                        :items="stores"
                        :loading="isLoading"
                        :placeholder="'Start typing to Search' | t"
                        class="col-item mt-0 pt-0 pb-0 mb-0"
                        color="bal-red"
                        dense
                        hide-no-data
                        hide-selected
                        item-text="name"
                        item-value="name"
                        outlined
                        @change="updateStoreField($event, 'company_name')"
                    />
                </v-col>
            </v-row>
            <v-divider class="my-2" />
            <v-row>
                <v-spacer />
                <v-btn class="px-2 mr-2 mt-3" color="bal-red" dark style="min-width: 0;" @click.stop="addNewStore">
                    <v-icon>add</v-icon>
                    <span>{{ "Add store" | t }}</span>
                </v-btn>
            </v-row>
        </div>
        <div v-else>
            <v-divider class="my-5 mb-1" />
            <v-row no-gutters class="text-end">
                <v-col>
                    <v-btn icon @click="resetNewStore()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Store name" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="shop.store.company_name"
                        @input="updateStoreField($event, 'company_name')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Chain name" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="shop.store.chain_name"
                        @input="updateStoreField($event, 'chain_name')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Identification code" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="shop.store.identification_code"
                        @input="updateStoreField($event, 'identification_code')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Company address" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="shop.store.address"
                        @input="updateStoreField($event, 'address')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Country" | t }}</v-col>
                <v-col cols="6">
                    <v-autocomplete
                        :value="shop.store.country"
                        @change="updateStoreField($event, 'country')"
                        :items="countries"
                        :loading="isLoading"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        hide-no-data
                        hide-selected
                        :item-text="
                            item =>
                                (item.name_et ? item.name_et : null) +
                                (item.name_en ? item.name_en : null) +
                                ' (' +
                                item.code +
                                ')'
                        "
                        item-value="code"
                        outlined
                        :placeholder="t('Start typing to Search')"
                    >
                        <template slot="selection" slot-scope="{ item, selected }">
                            {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                        </template>
                        <template slot="item" slot-scope="{ item, tile }">
                            <country-flag :country="item.code" size="small" class="mr-1" />
                            {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col :cols="1">
                    <country-flag
                        v-if="shop.store.country"
                        :country="shop.store.country"
                        class="mt-0 ml-1"
                        size="normal"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Store from "@/store";
import CountryFlag from "vue-country-flag";

export default {
    name: "store-view",
    data() {
        return {
            storesComplete: null,
            isLoading: false,
            addNew: false
        };
    },
    components: {
        CountryFlag
    },
    computed: {
        ...mapState("UnmatchedShopsStore", ["shop"]),
        ...mapState("ShopsAdminStore", ["stores"]),
        ...mapState(["countries"])
    },
    async mounted() {
        this.isLoading = true;
        await this.getStores();
        this.isLoading = false;
    },
    methods: {
        ...mapActions("ShopsAdminStore", ["getStores"]),
        updateStoreField(value, field) {
            Store.commit("UnmatchedShopsStore/updateNewStoreProperty", {
                prop: field,
                value: value
            });
        },
        addNewStore() {
            Store.commit("UnmatchedShopsStore/addNewStoreData");
            this.addNew = true;
        },
        resetNewStore() {
            Store.commit("UnmatchedShopsStore/resetNewStoreData");
            this.addNew = false;
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}
</style>
